<template>
    <div
        class="d-sidebar-searchbox"
        tabindex="-1"
        @click="clickHandler"
    >
        <DIcon name="magnify" />
        <span>{{ __('messages.searchbox.search') }}</span>
        <div
            v-if="!isMac"
            class="shortcut-hint"
        >
            CTRL+Space
        </div>
        <div
            v-if="isMac"
            class="shortcut-hint"
        >
            Control+Space
        </div>
    </div>
</template>

<script>
export default {
    name: 'DSidebarSearchbox',
    emits: ['search'],
    computed: {
        isMac: function () {
            return window.navigator.platform.toLocaleLowerCase().includes('mac')
        }
    },
    methods: {
        clickHandler () {
            this.emitter.emit('search', '')
        }
    }
}
</script>

<style lang="scss" scoped>
.d-sidebar-searchbox {
    display: grid;
    grid-template-columns: auto 1fr auto;
    grid-gap: 15px;
    padding: 7px 15px;
    border-radius: 4px;
    background: #F4F6F8;
    border: 1px solid #EAECEE;
    align-items: center;
    margin: 0px 15px 15px;
    cursor: text;

    & span {
        opacity: 0.4;
    }
    & .shortcut-hint {
        background: rgba(0,0,0,0.07);
        color: rgba(0,0,0,0.4);
        font-size: 9px;
        font-weight: bold;
        padding: 3px 5px;
        border-radius: 4px;
    }
}
</style>
